import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'User.Read',
    'Mail.Send',
    'Mail.ReadWrite',
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function connectOutlook(instance) {
  const result = await instance.loginPopup(loginRequest);
  return {
    accessToken: result.accessToken,
    account: result.account,
    email: result.account.username,
  };
}

export async function sendEmailViaGraph(accessToken, { to, subject, body }) {
  const response = await fetch('https://graph.microsoft.com/v1.0/me/sendMail', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      message: {
        subject,
        body: {
          contentType: 'HTML',
          content: body,
        },
        toRecipients: [
          {
            emailAddress: {
              address: to,
            },
          },
        ],
      },
      saveToSentItems: true,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error?.message || 'Failed to send email via Graph API');
  }

  return true;
}

export async function getGraphAccessToken(instance) {
  try {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) return null;

    const silentRequest = {
      scopes: loginRequest.scopes,
      account: accounts[0],
    };

    const result = await instance.acquireTokenSilent(silentRequest);
    return result.accessToken;
  } catch (err) {
    console.error('Silent token acquisition failed:', err);
    try {
      const result = await instance.acquireTokenPopup(loginRequest);
      return result.accessToken;
    } catch (popupErr) {
      console.error('Popup token acquisition failed:', popupErr);
      return null;
    }
  }
}